import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  id: 1,
  height: 'h-64',
  bg: 'linear-gradient(135deg, #1A3D2F 0%, #0B0B0B 100%)'
}, {
  id: 2,
  height: 'h-96',
  bg: 'linear-gradient(135deg, #2A4D3F 0%, #0B0B0B 100%)'
}, {
  id: 3,
  height: 'h-80',
  bg: 'linear-gradient(135deg, #1A3D2F 0%, #0B0B0B 100%)'
}, {
  id: 4,
  height: 'h-96',
  bg: 'linear-gradient(135deg, #2A4D3F 0%, #0B0B0B 100%)'
}, {
  id: 5,
  height: 'h-64',
  bg: 'linear-gradient(135deg, #1A3D2F 0%, #0B0B0B 100%)'
}, {
  id: 6,
  height: 'h-80',
  bg: 'linear-gradient(135deg, #2A4D3F 0%, #0B0B0B 100%)'
}];
export function Gallery() {
  return <section className="py-32 px-6 bg-matte-black" data-id="element-111">
      <div className="max-w-7xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-20" data-id="element-113">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-off-white mb-4" data-id="element-114">
            The Studio
          </h2>
          <p className="font-inter text-lg text-off-white/60" data-id="element-115">
            A glimpse into our world
          </p>
        </motion.div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-116">
          {images.map((img, index) => <motion.div key={img.id} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.1
        }} className={`relative w-full rounded-2xl overflow-hidden group ${img.height}`} data-id="element-117">
              <div className="absolute inset-0 transition-transform duration-700 group-hover:scale-110" style={{
            background: img.bg,
            filter: 'grayscale(100%)'
          }} data-id="element-118" />
              <div className="absolute inset-0 bg-matte-black/40 group-hover:bg-transparent transition-colors duration-500" data-id="element-119" />
              <div className="absolute inset-0 border border-off-white/10 rounded-2xl" data-id="element-120" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}